{
  "clusterList": {
    "cluster": {
      "actions": {
        "destroy": {
          "warning": {}
        },
        "remove": {},
        "start": {},
        "stop": {}
      },
      "fenceDevice": {
        "id": {},
        "status": {}
      },
      "fenceDeviceCount": {},
      "issue": {
        "message": {}
      },
      "issuesCount": {},
      "name": {},
      "node": {
        "name": {},
        "quorum": {},
        "status": {}
      },
      "nodeCount": {},
      "resource": {
        "id": {},
        "status": {}
      },
      "resourceCount": {},
      "status": {}
    }
  }
}
